(function () {
  "use strict";

  /* Scroll reveal */
  function initReveal() {
    var els = document.querySelectorAll(".rv");
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (e) { e.classList.add("in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (e) { if (!e.classList.contains("in")) io.observe(e); });
  }

  /* Mobile menu */
  function initNav() {
    var toggle = document.querySelector("[data-nav-toggle]");
    var menu = document.querySelector("[data-mobile-menu]");
    if (!toggle || !menu) return;
    var close = menu.querySelector("[data-nav-close]");
    function open() { menu.classList.add("open"); menu.setAttribute("aria-hidden", "false"); }
    function shut() { menu.classList.remove("open"); menu.setAttribute("aria-hidden", "true"); }
    toggle.addEventListener("click", open);
    if (close) close.addEventListener("click", shut);
    menu.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", shut); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") shut(); });
  }

  /* Region switcher: reveal footer region list */
  function initRegion() {
    document.querySelectorAll("[data-region-btn]").forEach(function (btn) {
            btn.addEventListener("click", function (e) {
        var target = document.querySelector("#region-switcher");
        e.preventDefault();
        if (target) { target.scrollIntoView({ behavior: "smooth", block: "start" }); }
        else { window.location.href = "/pages/worldwide#region-switcher"; }
      });
    });
  }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }
  ready(function () { initReveal(); initNav(); initRegion(); });
})();
